/**
 * Shared HITL 3.0 font size, defined once so it can be tuned in a single place
 * and reused across the hitl_3_0 UI — intent buttons, live-transcript messages,
 * Customer Pulse, modifier choices and the shortcuts popover.
 *
 * IMPORTANT: apply this ONLY behind the hitl_3_0 flag / inside hitl3-only
 * components. The legacy layout keeps its own sizes and must not reference this,
 * so bumping the value here never affects the old UI.
 */
export const HITL3_FONT_SIZE = '0.875rem'; // 14px at the 16px root

/**
 * Panel/section TITLE size for hitl_3_0 surfaces, one step above the body token.
 *
 * Deliberately a SECOND constant rather than a bump of HITL3_FONT_SIZE: that one is
 * the shared body size across 20+ call sites (intent buttons, transcript, Customer
 * Pulse, shortcuts popover) and raising it would resize all of them.
 *
 * Introduced for HITL-1501's issue-flag panel, whose heading has to read as a panel
 * title rather than one more line of body text.
 */
export const HITL3_TITLE_FONT_SIZE = '1.125rem'; // 18px at the 16px root
